module.exports = Storages;